import { msg } from '@lingui/core/macro'
import { defineEnum } from '@pkg/shared/utils/enum-builder'

export const PreferredCommunicationEnum = defineEnum({
  email: msg`E-Mail`,
  phone: msg`Telefon`,
  mobile: msg`Mobil`,
  fax: msg`Fax`,
})

export type PreferredCommunicationType = typeof PreferredCommunicationEnum.$.Type
